'use client';

import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useCallback } from 'react';

// 🔹 Tipo que gera caminhos válidos, mas impede modificar o pai diretamente
type EditablePath<T> = {

  // Permite modificar diretamente apenas valores primitivos
[K in keyof T & string]: T[K] extends object ? `${K}.${EditablePath<T[K]>}` // Permite acessar subpropriedades de objetos
: K }[keyof T & string];

// 🔹 Hook atualizado com validação correta
export default function useHandleInputChange(setState) {
  const $ = _c(2);
  let t0;
  if ($[0] !== setState) {
    t0 = (fieldPath, value) => {
      setState(prev => {
        const newState = structuredClone(prev);
        const keys = (fieldPath as string).split(".");
        let obj = newState;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!obj[keys[i]]) {
            obj[keys[i]] = {};
          }
          obj = obj[keys[i]];
          if (typeof obj !== "object" || obj === null) {
            throw new Error(`Não é possível modificar "${keys[i]}", apenas suas subpropriedades.`);
          }
        }
        obj[keys[keys.length - 1]] = value;
        return newState;
      });
    };
    $[0] = setState;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}